import React from "react";
import logo from "./logo.svg";
import { defaultTheme } from "./common/theme";
import "./App.css";
import { BrowserRouter, Router, RouterProvider } from "react-router-dom";
import { configureStore } from "./redux/store";
import { createBrowserHistory } from "history";
import RouterComponent from "./screens/Router";
import { Provider, Provider as StoreProvider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
const GOOGLE_CLIENT_ID =
  "959606247969-ao02vfnhjs8f4i8jrigvl2t17mpfvl0l.apps.googleusercontent.com";
// const history = createBrowserHistory();
const store = configureStore();
function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <StoreProvider store={store}>
        <BrowserRouter>
          <RouterComponent />
        </BrowserRouter>
      </StoreProvider>
    </GoogleOAuthProvider>

    //     <Provider store={store}>
    //       <ThemeProvider theme={defaultTheme}>
    // <RouterComponent/>
    //       </ThemeProvider>
    //     </Provider>
  );
}

export default App;
